import {
  breakpoints,
  ActionButtonWithConfirmation,
  theme,
} from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const buyButtonWrappableCss = css`
  white-space: normal;
  line-height: 1.4;
`;

export const StyledBuyButton = styled(ActionButtonWithConfirmation)`
  text-transform: none !important;

  @media (min-width: ${breakpoints.xs}) {
    width: 100% !important;
    text-align: center;
  }

  ${theme.typography.labelRegular}
  span {
    font-weight: 500 !important;
  }
`;
